// if (!customElements.get('product-form')) {
//   customElements.define(
//     'product-form',
//     class ProductForm extends HTMLElement {
//       constructor() {
//         super();

//         this.form = this.querySelector('form');
//         this.variantIdInput.disabled = false;
//         this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//         this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//         this.submitButton = this.querySelector('[type="submit"]');
//         this.submitButtonText = this.submitButton.querySelector('span');

//         if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

//         this.hideErrors = this.dataset.hideErrors === 'true';
//       }

//       onSubmitHandler(evt) {
//         evt.preventDefault();
//         if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

//         this.handleErrorMessage();

//         this.submitButton.setAttribute('aria-disabled', true);
//         this.submitButton.classList.add('loading');
//         this.querySelector('.loading__spinner').classList.remove('hidden');

//         const config = fetchConfig('javascript');
//         config.headers['X-Requested-With'] = 'XMLHttpRequest';
//         delete config.headers['Content-Type'];

//         const formData = new FormData(this.form);
//         if (this.cart) {
//           formData.append(
//             'sections',
//             this.cart.getSectionsToRender().map((section) => section.id)
//           );
//           formData.append('sections_url', window.location.pathname);
//           this.cart.setActiveElement(document.activeElement);
//         }
//         config.body = formData;

//         fetch(`${routes.cart_add_url}`, config)
//           .then((response) => response.json())
//           .then((response) => {
//             if (response.status) {
//               publish(PUB_SUB_EVENTS.cartError, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 errors: response.errors || response.description,
//                 message: response.message,
//               });
//               this.handleErrorMessage(response.description);

//               const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//               if (!soldOutMessage) return;
//               this.submitButton.setAttribute('aria-disabled', true);
//               this.submitButtonText.classList.add('hidden');
//               soldOutMessage.classList.remove('hidden');
//               this.error = true;
//               return;
//             } else if (!this.cart) {
//               window.location = window.routes.cart_url;
//               return;
//             }

//             const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
//             if (!this.error)
//               publish(PUB_SUB_EVENTS.cartUpdate, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 cartData: response,
//               }).then(() => {
//                 CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
//               });
//             this.error = false;
//             const quickAddModal = this.closest('quick-add-modal');
//             if (quickAddModal) {
//               document.body.addEventListener(
//                 'modalClosed',
//                 () => {
//                   setTimeout(() => {
//                     CartPerformance.measure("add:paint-updated-sections", () => {
//                       this.cart.renderContents(response);
//                     });
//                   });
//                 },
//                 { once: true }
//               );
//               quickAddModal.hide(true);
//             } else {
//               CartPerformance.measure("add:paint-updated-sections", () => {
//                 this.cart.renderContents(response);
//               });
//             }
//           })
//           .catch((e) => {
//             console.error(e);
//           })
//           .finally(() => {
//             this.submitButton.classList.remove('loading');
//             if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//             if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//             this.querySelector('.loading__spinner').classList.add('hidden');

//             CartPerformance.measureFromEvent("add:user-action", evt);
//           });
//       }

//       handleErrorMessage(errorMessage = false) {
//         if (this.hideErrors) return;

//         this.errorMessageWrapper =
//           this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//         if (!this.errorMessageWrapper) return;
//         this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//         this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//         if (errorMessage) {
//           this.errorMessage.textContent = errorMessage;
//         }
//       }

//       toggleSubmitButton(disable = true, text) {
//         if (disable) {
//           this.submitButton.setAttribute('disabled', 'disabled');
//           if (text) this.submitButtonText.textContent = text;
//         } else {
//           this.submitButton.removeAttribute('disabled');
//           this.submitButtonText.textContent = window.variantStrings.addToCart;
//         }
//       }

//       get variantIdInput() {
//         return this.form.querySelector('[name=id]');
//       }
//     }
//   );
// }

// if (!customElements.get('product-form')) {
//   customElements.define(
//     'product-form',
//     class ProductForm extends HTMLElement {
//       constructor() {
//         super();

//         this.form = this.querySelector('form');
//         this.variantIdInput.disabled = false;
//         this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
//         this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
//         this.submitButton = this.querySelector('[type="submit"]');
//         this.submitButtonText = this.submitButton.querySelector('span');

//         if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

//         this.hideErrors = this.dataset.hideErrors === 'true';
//       }

//       onSubmitHandler(evt) {
//         evt.preventDefault();
//         if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

//         this.handleErrorMessage();

//         this.submitButton.setAttribute('aria-disabled', true);
//         this.submitButton.classList.add('loading');
//         if (this.querySelector('.loading__spinner')) {
//           this.querySelector('.loading__spinner').classList.remove('hidden');
//         }

//         const config = fetchConfig('javascript');
//         config.headers['X-Requested-With'] = 'XMLHttpRequest';
//         delete config.headers['Content-Type'];

//         const formData = new FormData(this.form);
//         if (this.cart) {
//           formData.append(
//             'sections',
//             this.cart.getSectionsToRender().map((section) => section.id)
//           );
//           formData.append('sections_url', window.location.pathname);
//           this.cart.setActiveElement(document.activeElement);
//         }
//         config.body = formData;

//         fetch(`${routes.cart_add_url}`, config)
//           .then((response) => response.json())
//           .then((response) => {
//             if (response.status) {
//               publish(PUB_SUB_EVENTS.cartError, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 errors: response.errors || response.description,
//                 message: response.message,
//               });
//               this.handleErrorMessage(response.description);

//               const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
//               if (!soldOutMessage) return;
//               this.submitButton.setAttribute('aria-disabled', true);
//               this.submitButtonText.classList.add('hidden');
//               soldOutMessage.classList.remove('hidden');
//               this.error = true;
//               return;
//             } else if (!this.cart) {
//               window.location = window.routes.cart_url;
//               return;
//             }

//             const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
//             if (!this.error)
//               publish(PUB_SUB_EVENTS.cartUpdate, {
//                 source: 'product-form',
//                 productVariantId: formData.get('id'),
//                 cartData: response,
//               }).then(() => {
//                 CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
//               });
//             this.error = false;

//             const quickAddModal = this.closest('quick-add-modal');

//             if (quickAddModal) {
//               document.body.addEventListener(
//                 'modalClosed',
//                 () => {
//                   setTimeout(() => {
//                     CartPerformance.measure("add:paint-updated-sections", () => {
//                       this.cart.renderContents(response);

//                       /* ------------------------------
//                          TERMS CHECKBOX FUNCTIONALITY
//                          ------------------------------ */
//                       initCartTermsCheckbox();
//                     });
//                   });
//                 },
//                 { once: true }
//               );
//               quickAddModal.hide(true);
//             } else {
//               CartPerformance.measure("add:paint-updated-sections", () => {
//                 this.cart.renderContents(response);

//                 /* ------------------------------
//                    TERMS CHECKBOX FUNCTIONALITY
//                    ------------------------------ */
//                 initCartTermsCheckbox();
//               });
//             }
//           })
//           .catch((e) => {
//             console.error(e);
//           })
//           .finally(() => {
//             this.submitButton.classList.remove('loading');
//             if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
//             if (!this.error) this.submitButton.removeAttribute('aria-disabled');
//             if (this.querySelector('.loading__spinner')) {
//               this.querySelector('.loading__spinner').classList.add('hidden');
//             }

//             CartPerformance.measureFromEvent("add:user-action", evt);
//           });
//       }

//       handleErrorMessage(errorMessage = false) {
//         if (this.hideErrors) return;

//         this.errorMessageWrapper =
//           this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
//         if (!this.errorMessageWrapper) return;
//         this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

//         this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

//         if (errorMessage) {
//           this.errorMessage.textContent = errorMessage;
//         }
//       }

//       toggleSubmitButton(disable = true, text) {
//         if (disable) {
//           this.submitButton.setAttribute('disabled', 'disabled');
//           if (text) this.submitButtonText.textContent = text;
//         } else {
//           this.submitButton.removeAttribute('disabled');
//           this.submitButtonText.textContent = window.variantStrings.addToCart;
//         }
//       }

//       get variantIdInput() {
//         return this.form.querySelector('[name=id]');
//       }
//     }
//   );
// }


// /* =====================================================
//    TERMS & CONDITIONS CHECKBOX LOGIC (NEW CODE ONLY)
//    ===================================================== */

// function initCartTermsCheckbox() {

//   const checkbox = document.querySelector(".js-cart-terms-input");
//   const checkoutBtn = document.querySelector("#cart-notification-form button[name='checkout']");
//   const error = document.querySelector(".js-cart-terms-error");

//   if (!checkbox || !checkoutBtn) return;

//   checkoutBtn.setAttribute("disabled", "disabled");

//   checkbox.addEventListener("change", function () {

//     if (checkbox.checked) {
//       checkoutBtn.removeAttribute("disabled");
//       if (error) error.style.display = "none";
//     } else {
//       checkoutBtn.setAttribute("disabled", "disabled");
//     }

//   });

//   checkoutBtn.addEventListener("click", function(e){

//     if(!checkbox.checked){

//       e.preventDefault();

//       if(error){
//         error.style.display = "block";
//       }

//     }

//   });

// }

/* ============================================================
   product-form.js
   Handles the MAIN product form add-to-cart with:
   - Dog tag field validation (blocks submit if fields empty)
   - Dog tag property injection into FormData before fetch
   - Cart notification popup rendering
   - Terms & conditions checkbox
   ============================================================ */

if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');
        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) {
          this.submitButton.setAttribute('aria-haspopup', 'dialog');
        }

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      onSubmitHandler(evt) {
        evt.preventDefault();
        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;

        /* ── Dog Tag validation — hard stop before any fetch ────── */
        var dogTagBlock = document.querySelector('#dog-tag-fields');
        if (dogTagBlock && window.DogTagFields) {
          if (!window.DogTagFields.validate()) {
            window.DogTagFields.scrollToFields();
            return;
          }
        }

        this.handleErrorMessage();
        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        if (this.querySelector('.loading__spinner')) {
          this.querySelector('.loading__spinner').classList.remove('hidden');
        }

        const config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);

        /* ── Inject dog-tag properties into FormData ─────────────── */
        if (dogTagBlock && window.DogTagFields) {
          window.DogTagFields.injectIntoFormData(formData);
        }

        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }
        config.body = formData;

        fetch(`${routes.cart_add_url}`, config)
          .then((response) => response.json())
          .then((response) => {
            if (response.status) {
              publish(PUB_SUB_EVENTS.cartError, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                errors: response.errors || response.description,
                message: response.message,
              });
              this.handleErrorMessage(response.description);

              const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
              if (!soldOutMessage) return;
              this.submitButton.setAttribute('aria-disabled', true);
              this.submitButtonText.classList.add('hidden');
              soldOutMessage.classList.remove('hidden');
              this.error = true;
              return;
            } else if (!this.cart) {
              /* this.cart is null — should not happen for main form,
                 but guard against redirect just in case */
              window.location = window.routes.cart_url;
              return;
            }

            const startMarker = CartPerformance.createStartingMarker('add:wait-for-subscribers');
            // If we're already on the cart page, reload after successful add
              if (window.location.pathname === window.routes.cart_url) {
                setTimeout(() => {
                  window.location.reload();
                }, 200);
                return;
              }
            if (!this.error)
              publish(PUB_SUB_EVENTS.cartUpdate, {
                source: 'product-form',
                productVariantId: formData.get('id'),
                cartData: response,
              }).then(() => {
                CartPerformance.measureFromMarker('add:wait-for-subscribers', startMarker);
              });
            this.error = false;

            const quickAddModal = this.closest('quick-add-modal');
            if (quickAddModal) {
              document.body.addEventListener(
                'modalClosed',
                () => {
                  setTimeout(() => {
                    CartPerformance.measure('add:paint-updated-sections', () => {
                      this.cart.renderContents(response);
                      initCartTermsCheckbox();
                    });
                  });
                },
                { once: true }
              );
              quickAddModal.hide(true);
            } else {
              CartPerformance.measure('add:paint-updated-sections', () => {
                this.cart.renderContents(response);
                initCartTermsCheckbox();
              });
            }
          })
          .catch((e) => {
            console.error(e);
          })
          .finally(() => {
            this.submitButton.classList.remove('loading');
            if (this.cart && this.cart.classList.contains('is-empty')) {
              this.cart.classList.remove('is-empty');
            }
            if (!this.error) this.submitButton.removeAttribute('aria-disabled');
            if (this.querySelector('.loading__spinner')) {
              this.querySelector('.loading__spinner').classList.add('hidden');
            }
            CartPerformance.measureFromEvent('add:user-action', evt);
          });
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;
        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage =
          this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');
        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);
        if (errorMessage) this.errorMessage.textContent = errorMessage;
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

/* =====================================================
   TERMS & CONDITIONS CHECKBOX LOGIC
   ===================================================== */
function initCartTermsCheckbox() {
  const checkbox   = document.querySelector('.js-cart-terms-input');
  const checkoutBtn = document.querySelector("#cart-notification-form button[name='checkout']");
  const error      = document.querySelector('.js-cart-terms-error');

  if (!checkbox || !checkoutBtn) return;

  // checkoutBtn.setAttribute('disabled', 'disabled');

  checkbox.addEventListener('change', function () {
    if (checkbox.checked) {
      checkoutBtn.removeAttribute('disabled');
      if (error) error.style.display = 'none';
    } else {
      checkoutBtn.setAttribute('disabled', 'disabled');
    }
  });

  checkoutBtn.addEventListener('click', function (e) {
    if (!checkbox.checked) {
      e.preventDefault();
      if (error) error.style.display = 'block';
    }
  });
}

/* =====================================================
   DOG TAG FIELDS — window.DogTagFields global helper
   ===================================================== */
(function () {
  'use strict';

  function init() {
    var block = document.querySelector('#dog-tag-fields');
    if (!block) return;

    var fieldInputs = Array.from(block.querySelectorAll('.dog-tag-field__input'));

    /* Character counters */
    fieldInputs.forEach(function (input) {
      var wrap    = input.closest('.dog-tag-field__input-wrap');
      var counter = wrap.querySelector('.dog-tag-field__counter');
      var countEl = counter.querySelector('.dtag-count');
      var errorEl = input.closest('.dog-tag-field').querySelector('.dog-tag-field__error');

      input.addEventListener('input', function () {
        var len = input.value.length;
        countEl.textContent = len;
        counter.classList.toggle('is-max', len >= 15);
        if (len > 0) {
          input.classList.remove('is-error');
          errorEl.classList.remove('is-visible');
        }
      });
    });

    // window.DogTagFields = {
    //   validate: function () {
    //     var valid = true;
    //     fieldInputs.forEach(function (input) {
    //       var errorEl = input.closest('.dog-tag-field').querySelector('.dog-tag-field__error');
    //       if (input.value.trim() === '') {
    //         valid = false;
    //         input.classList.add('is-error');
    //         errorEl.classList.add('is-visible');
    //       } else {
    //         input.classList.remove('is-error');
    //         errorEl.classList.remove('is-visible');
    //       }
    //     });
    //     if (!valid) block.classList.add('has-errors');
    //     return valid;
    //   },
     

    //   injectIntoFormData: function (formData) {
    //     fieldInputs.forEach(function (input) {
    //       var fieldName = input.getAttribute('data-dog-tag-field');
    //       if (fieldName) {
    //         try { formData.delete('properties[' + fieldName + ']'); } catch (e) {}
    //         formData.append('properties[' + fieldName + ']', input.value.trim());
    //       }
    //     });
    //   },

    //   scrollToFields: function () {
    //     var top = block.getBoundingClientRect().top + window.scrollY - 100;
    //     window.scrollTo({ top: top, behavior: 'smooth' });
    //     setTimeout(function () {
    //       var firstEmpty = fieldInputs.find(function (i) { return i.value.trim() === ''; });
    //       if (firstEmpty) firstEmpty.focus();
    //     }, 450);
    //   }
    // };
    window.DogTagFields = {
      validate: function () {

        var valid = true;

        // clear previous errors
        block.querySelectorAll('.dog-tag-field__input').forEach(function(input){
          input.classList.remove('is-error');
        });

        block.querySelectorAll('.dog-tag-field__error').forEach(function(error){
          error.classList.remove('is-visible');
        });

        // validate ONLY required fields
        var requiredFields = block.querySelectorAll('[data-required="true"]');

        requiredFields.forEach(function(input){

          var errorEl = input
            .closest('.dog-tag-field')
            .querySelector('.dog-tag-field__error');

          if (input.value.trim() === '') {

            valid = false;

            input.classList.add('is-error');

            if (errorEl) {
              errorEl.classList.add('is-visible');
            }
          }

        });

        block.classList.toggle('has-errors', !valid);

        return valid;
      },

      injectIntoFormData: function (formData) {
        fieldInputs.forEach(function (input) {
          var fieldName = input.getAttribute('data-dog-tag-field');

          if (fieldName && input.value.trim()) {
            formData.append(
              'properties[' + fieldName + ']',
              input.value.trim()
            );
          }
        });
      },

      scrollToFields: function () {
        block.scrollIntoView({
          behavior: 'smooth',
          block: 'center'
        });
      }
    };
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();